export default "__VITE_ASSET__8d003130__"